module.exports = __webpack_public_path__ + "img/emptyState.db3080dc.svg";